import { Pagination, Tooltip } from "antd";
import { FiEdit2, FiTrash2, FiEye } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Table } from "reactstrap";
import NotFoundDataUI from "../cards/NotFoundDataUI";

const ManufacturerTable = ({
  data,
  setSelectedObj,
  setModal,
  setSelectedMfg,
  toggleDelete,
  page,
  setPage,
  totalPages,
  pageSize,
  setPageSize,
  onClearSearch,
}) => {
  const history = useHistory();
  const { user } = useSelector((state) => state.auth);

  return (
    <div>
      <Table
        responsive
        hover
        bordered
        className="mb-0"
        style={{
          fontSize: "15px",
          overflow: "hidden",
          border: "1px solid #e2e8f0"
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#00509d", color: "white" }}>
            <th className="text-center" style={{ borderBottom: "none" }}>ID</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Name</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Phone</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Email</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((row, index) => (
              <tr
                key={index}
                className="align-middle"
                style={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                  borderBottom: "1px solid #f1f5f9"
                }}
              >
                <td className="text-center text-muted small fw-bold">
                  {row.id}
                </td>
                <td className="text-center fw-bold">{row.name ?? "Not Given"}</td>
                <td className="text-center">{row.phone ?? "Not Given"}</td>
                <td className="text-center text-muted italic">
                  {row.email && row.email !== "" ? row.email : "Not Given"}
                </td>
                <td className="text-center">
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <Tooltip title="Edit Manufacturer">
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() => {
                          setSelectedObj(row);
                          setModal(true);
                        }}
                      >
                        <FiEdit2 className="text-primary" size={14} />
                      </Button>
                    </Tooltip>

                    <Tooltip title="View Details">
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() => {
                          history.push({
                            pathname: `/admin/manufacturer-details/${row?._id}`,
                            state: row,
                          });
                        }}
                      >
                        <FiEye className="text-info" size={18} />
                      </Button>
                    </Tooltip>

                    {(user?.role === "Admin" || user?.role === "Super-admin") && (
                      <Tooltip title="Delete Manufacturer">
                        <Button
                          color="link"
                          className="p-1 border-0"
                          onClick={() => {
                            setSelectedMfg(row);
                            toggleDelete();
                          }}
                        >
                          <FiTrash2 className="text-danger" size={16} />
                        </Button>
                      </Tooltip>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center py-4">
                <NotFoundDataUI 
                  message="No manufacturers found!" 
                  onClearSearch={onClearSearch}
                  onCreateNew={() => {
                    setSelectedObj(null);
                    setModal(true);
                  }}
                />
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {data && data.length > 0 && (
        <div className="d-flex justify-content-end mt-3 px-2">
          <Pagination
            size="small"
            current={page}
            total={totalPages}
            onChange={(value) => {
              localStorage.setItem("manufacturerPage", value);
              setPage(value);
            }}
            pageSize={pageSize}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setPage(1);
            }}
            pageSizeOptions={['10', '25', '50', '100']}
          />
        </div>
      )}
    </div>
  );
};

export default ManufacturerTable;
